/**
 *@file server-config.js
 *@version 1.0.1
 * @description   所有服务器的url配置
 */
// 测试环境
// const dirServicePath = '/api';
//
// 正式环境
const dirServicePath = window.location.origin;
const dirServicePath2 = 'https://www.wdcm.org';

// 服务数据
const serverUrl = {
    visitTotal:'https://nmdc.cn/api/services/nmdcweb/api/subdomains/query/VisitsNumber/wdcm',
    trainingcouses: {
        list: `${dirServicePath}/static_materails/jsonfiles/trainingcousesList.json`,
        info: `${dirServicePath}/static_materails/jsonfiles/trainingcouses/`
    },
    news: {
        list: `${dirServicePath}/static_materails/jsonfiles/newslist.json`,
        info: `${dirServicePath}/static_materails/jsonfiles/news/`
    },
    events: {
        list: `${dirServicePath}/static_materails/jsonfiles/eventslist.json`,
        info: `${dirServicePath}/static_materails/jsonfiles/events/`
    },
    projects: {
        list: `${dirServicePath}/static_materails/jsonfiles/projectslist.json`,
    },
    cooperation: {
        list: `${dirServicePath}/static_materails/jsonfiles/cooperationlist.json`,
        map: `${dirServicePath}/static_materails/jsonfiles/cooperation.json`
    },
    home: {
        static: `${dirServicePath2}/ccinfoapi/search/static`,
        ccinfo: `${dirServicePath2}/ccinfoapi/search/homestatic`,
        data: `${dirServicePath}/static_materails/jsonfiles/home.json`,
        gcm:`${dirServicePath2}/gcmapi/api/statistics/global`
    },

};
export default serverUrl;



// WEBPACK FOOTER //
// ./src/js/server-config.js